import type { HomeExclusiveDrop } from './homeDrops';
import { HomeDropTile } from './HomeDropTile';

type HomeDropsScrollRailProps = Readonly<{
  drops: readonly HomeExclusiveDrop[];
}>;

/**
 * Full-bleed native horizontal rail — snap scroll, no scroll-jacking (better UX + perf).
 */
export function HomeDropsScrollRail({ drops }: HomeDropsScrollRailProps) {
  return (
    <div id="drops-rail" className="home-popular-rail scroll-mt-24">
      <div className="home-popular-rail__fade home-popular-rail__fade--left" aria-hidden />
      <div className="home-popular-rail__fade home-popular-rail__fade--right" aria-hidden />

      <div className="home-popular-rail__track flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-2">
        {drops.map((drop, index) => (
          <HomeDropTile
            key={`${drop.slug}-${index}`}
            drop={drop}
            variant="rail"
            priority={index < 2}
            tileIndex={index}
          />
        ))}
      </div>
    </div>
  );
}
